import React from 'react';

import className from 'classnames';
import { observer } from 'mobx-react';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './TitleRowDesktop.module.scss';

import {
  GridTableCell,
  GridTableRow,
  GridTableRowVariant,
} from '../../../../../../shared/components/table-components';
import {
  LEADERBOARD_COLUMN,
  LeaderboardColumn,
  RenderColumnInfo,
} from '../../../ChallengeLeaderboard.settings';
import { leaderboardStore } from '../../../../../stores/leaderboardStore';
import { SortButtons } from '../../../../../../shared/components/buttons/SortButtons/SortButtons';

type TitleRowDesktopProps = {
  leaderboardColumns: LeaderboardColumn[];
  variant?: GridTableRowVariant;
};

const TitleRowDesktop = observer(
  ({ leaderboardColumns, variant = 'header' }: TitleRowDesktopProps) => {
    const { filterMethods } = leaderboardStore;
    const { handleSort, getIsSortedBy } = filterMethods;

    const rowClass = className(classes.row, {
      [classes.unstyled]: variant === 'unstyled',
    });

    const renderColumnsInfo: RenderColumnInfo = {
      [LEADERBOARD_COLUMN.RANK]: (
        <GridTableCell>
          <SortButtons fieldName="RANK" onSort={handleSort} getIsActive={getIsSortedBy}>
            Rank
          </SortButtons>
        </GridTableCell>
      ),
      [LEADERBOARD_COLUMN.INITIAL_SCAN_INDICATOR]: <GridTableCell />,
      [LEADERBOARD_COLUMN.CUSTOMER]: <GridTableCell>Customer</GridTableCell>,
      [LEADERBOARD_COLUMN.TOTAL_SCORE]: (
        <GridTableCell>
          <SortButtons
            fieldName="TOTAL_SCORE"
            onSort={handleSort}
            getIsActive={getIsSortedBy}
          >
            Total Score
          </SortButtons>
        </GridTableCell>
      ),
      [LEADERBOARD_COLUMN.FOOD_TRACKING_PERCENT]: (
        <GridTableCell>
          <SortButtons
            fieldName="FOOD_TRACKING_PERCENTAGE"
            onSort={handleSort}
            getIsActive={getIsSortedBy}
          >
            <TitleWithDescription
              titleFont="body-14-bold"
              title="Food Tracking"
              description="%"
            />
          </SortButtons>
        </GridTableCell>
      ),
      [LEADERBOARD_COLUMN.FOOD_TRACKING_RANK]: (
        <GridTableCell>
          <SortButtons
            fieldName="FOOD_TRACKING_RANK"
            onSort={handleSort}
            getIsActive={getIsSortedBy}
          >
            <TitleWithDescription
              titleFont="body-14-bold"
              title="Food Tracking"
              description="rank"
            />
          </SortButtons>
        </GridTableCell>
      ),
      [LEADERBOARD_COLUMN.FAT_LOSS_PERCENT]: (
        <GridTableCell>
          <SortButtons
            fieldName="FAT_LOSS_PERCENTAGE"
            onSort={handleSort}
            getIsActive={getIsSortedBy}
          >
            <TitleWithDescription
              titleFont="body-14-bold"
              title="Fat Loss"
              description="%"
            />
          </SortButtons>
        </GridTableCell>
      ),
      [LEADERBOARD_COLUMN.ADJUSTED_FAT_LOSS_PERCENT]: (
        <GridTableCell>
          <SortButtons
            fieldName="ADJUSTED_FAT_LOSS_PERCENTAGE"
            onSort={handleSort}
            getIsActive={getIsSortedBy}
          >
            <TitleWithDescription
              titleFont="body-14-bold"
              title="Adjusted Fat Loss"
              description="%"
            />
          </SortButtons>
        </GridTableCell>
      ),
      [LEADERBOARD_COLUMN.FAT_LOSS_RANK]: (
        <GridTableCell>
          <SortButtons
            fieldName="FAT_LOSS_RANK"
            onSort={handleSort}
            getIsActive={getIsSortedBy}
          >
            <TitleWithDescription
              titleFont="body-14-bold"
              title="Fat Loss"
              description="rank"
            />
          </SortButtons>
        </GridTableCell>
      ),
      [LEADERBOARD_COLUMN.FAT_LOSS_LBS]: (
        <GridTableCell>
          <SortButtons
            fieldName="FAT_LOSS_LBS"
            onSort={handleSort}
            getIsActive={getIsSortedBy}
          >
            <TitleWithDescription
              titleFont="body-14-bold"
              title="Fat Loss"
              description="lbs"
            />
          </SortButtons>
        </GridTableCell>
      ),
      [LEADERBOARD_COLUMN.MUSCLE_GAIN_LBS]: (
        <GridTableCell>
          <SortButtons
            fieldName="MUSCLE_GAIN_LBS"
            onSort={handleSort}
            getIsActive={getIsSortedBy}
          >
            <TitleWithDescription
              titleFont="body-14-bold"
              title="Muscle Gain"
              description="lbs"
            />
          </SortButtons>
        </GridTableCell>
      ),
      [LEADERBOARD_COLUMN.MUSCLE_MULTIPLIER]: (
        <GridTableCell>Muscle Multiplier</GridTableCell>
      ),
      [LEADERBOARD_COLUMN.ADJUSTED_SCORE_PERCENT]: (
        <GridTableCell>
          <SortButtons
            fieldName="ADJUSTED_FAT_LOSS_PERCENTAGE"
            onSort={handleSort}
            getIsActive={getIsSortedBy}
          >
            <TitleWithDescription
              titleFont="body-14-bold"
              title="Adjusted Score"
              description="%"
            />
          </SortButtons>
        </GridTableCell>
      ),
    };

    return (
      <GridTableRow variant={variant} className={rowClass}>
        {leaderboardColumns.map((column) => (
          <React.Fragment key={column}>{renderColumnsInfo[column]}</React.Fragment>
        ))}
      </GridTableRow>
    );
  },
);

export { TitleRowDesktop };
